import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Server } from '../server/server';
import { AppConfig } from './AppConfig';
import HomePage from './pages/HomePage';
import SitePage from './pages/SitePage';
import SettingsPage from './pages/SettingsPage';
import FriendsPage from './pages/FriendsPage';
import ProfilePage from './pages/ProfilePage';
import MediaPage from './pages/MediaPage';
import StatsPage from './pages/StatsPage';
import ChatPage from './pages/ChatPage';
import NotFoundPage from './pages/NotFoundPage';
import HistoryPage from './pages/HistoryPage';
import ActivityPage from './pages/ActivityPage';
import ActivityPostPage from './pages/ActivityPostPage';
import BlogPage from './pages/BlogPage';
import BlogsPage from './pages/BlogsPage';
import EditBlogPage from './pages/EditBlogPage';
import ForumContentPage from './pages/ForumContentPage';
import ForumPage from './pages/ForumPage';
import ForumTopicPage from './pages/ForumTopicPage';
import ForumsPage from './pages/ForumsPage';
import NotificationsPage from './pages/NotificationsPage';
import CreateCommunityPage from './pages/CreateCommunityPage';
import AdminPage from './pages/AdminPage';
import AdminThemePage from './pages/AdminThemePage';
import withRouter from './util/withRouter';
import SecretPasswordPage from './pages/SecretPasswordPage';
import SplashPage from './pages/SplashPage';
import DashboardPage from './pages/DashboardPage';
import JoinCommunityPage from './pages/JoinCommunityPage';
import EditForumPage from './pages/EditForumPage';
import UsersPage from './pages/UsersPage';
import CommunityInvitesPage from './pages/CommunityInvitesPage';
import CommunityInvitePage from './pages/CommunityInvitePage';
import AccountPage from './pages/AccountPage';
import './App.css';

const ProfilePageWithRouter = withRouter(ProfilePage);
const UsersPageWithRouter = withRouter(UsersPage);

function RequireAuth({ children }) {
  return Server.account.isLoggedIn() ? children : <Navigate to="/" replace />;
}

interface AppState {
  initialized: boolean;
};

class App extends React.Component<{}, AppState> {
  constructor(props = {}) {
    super(props);

    this.state = {
      initialized: false
    }
  }

  componentDidMount() {
    // window.localStorage.removeItem('SecretPassword');

    window.addEventListener('beforeinstallprompt', (e)=> {
      SettingsPage.pwa = e;
    });

    window.addEventListener("beforeunload", function (e) {
      Server.network.disconnect();
    });

    Server.account.addEventListener('login', ()=>{
      this.forceUpdate();
    });

    Server.account.addEventListener('logout', ()=>{
      this.setInitialized(false)
    });
  }

  setInitialized(i:boolean) {
    this.setState({initialized: i})
  }

  isSecretPasswordValid() {
    let sp = window.localStorage.getItem('SecretPassword');
    return (sp == 'converge');
  }

  render() {
    if(!this.isSecretPasswordValid()) 
      return (<SecretPasswordPage />);

    if(!this.state.initialized) 
      return (<SplashPage onInit={()=>this.setInitialized(true)}/>);

    if(AppConfig.community) {
      return (
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<SitePage />}>
              <Route index element={<Navigate replace to="/activity" />} />
              <Route path='/activity' element={<ActivityPage />} />
              <Route path='/activity/hashtag/:id' element={<ActivityPage />} />
              <Route path='/activity/post/:id' element={<ActivityPostPage />} />
              <Route path='/admin' element={<AdminPage />} />
              <Route path='/admin/theme' element={<AdminThemePage />} />
              <Route path='/members' element={<UsersPageWithRouter />} />
              <Route path='/invites' element={<CommunityInvitesPage />} />
              <Route path='/invite' element={<CommunityInvitePage />} />
              <Route path='/blogs' element={<BlogsPage />} />
              <Route path='/blog/:id' element={<BlogPage />} />
              <Route path='/blog/new' element={<EditBlogPage />} />
              <Route path='/blog/edit/:id' element={<EditBlogPage />} />
              <Route path='/forums' element={<ForumsPage />} />
              <Route path='/forum/create' element={<EditForumPage />} />
              <Route path='/forum/:fid' element={<ForumPage />} />
              <Route path='/forum/:fid/edit' element={<EditForumPage />} />
              <Route path='/forum/:fid/new' element={<ForumContentPage />} />
              <Route path='/forum/:fid/:tid' element={<ForumTopicPage />} />
              <Route path='/forum/:fid/:tid/edit' element={<ForumContentPage />} />
              <Route path='/forum/:fid/:tid/new' element={<ForumContentPage />} />
              <Route path='/forum/:fid/:tid/:pid/edit' element={<ForumContentPage />} />
              <Route path='/friends' element={<FriendsPage />} />
              <Route path='/chat' element={<ChatPage />} />
              <Route path='/notifications' element={<NotificationsPage />} />
              <Route path='/profile' element={<ProfilePageWithRouter />} />
              <Route path='/profile/:id' element={<ProfilePageWithRouter />} />
              <Route path='/profile/:id/followers' element={<UsersPageWithRouter />} />
              <Route path='/profile/:id/following' element={<UsersPageWithRouter />} />
              <Route path='/media' element={<MediaPage />} />
              <Route path='/stats' element={<StatsPage />} />
              <Route path='/history' element={<HistoryPage />} />
              <Route path='/account' element={<AccountPage />} />
              <Route path='/settings' element={<SettingsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      );
    }
    else {
      return (
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<SitePage />}>
              <Route index element={<HomePage />} />
              <Route path='/dashboard' element={<RequireAuth><DashboardPage/></RequireAuth>} />
              <Route path='/media' element={<RequireAuth><MediaPage/></RequireAuth>} />
              <Route path='/stats' element={<RequireAuth><StatsPage/></RequireAuth>} />
              <Route path='/history' element={<RequireAuth><HistoryPage/></RequireAuth>} />
              <Route path='/account' element={<RequireAuth><AccountPage/></RequireAuth>} />
              <Route path='/create' element={<RequireAuth><CreateCommunityPage/></RequireAuth>} />
              <Route path='/join' element={<RequireAuth><JoinCommunityPage/></RequireAuth>} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      );
    }
      
  }
}

export default App;
